import { render } from "./steps.vue?vue&type=template&id=2fe19b3a&scoped=true"
import script from "./steps.vue?vue&type=script&lang=js"
export * from "./steps.vue?vue&type=script&lang=js"

import "./steps.vue?vue&type=style&index=0&id=2fe19b3a&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe19b3a"]])

export default __exports__